import { getLocalApi } from './localApi';
import apiConfig from 'app/api/apiConfig.json';
import { getSelectedDivisionId } from 'app/shared/division/selectedDivisionStorage';
import { ApiErrors } from './ApiErrors';

export async function saveAccommodationRoom(
  payload: any,
  divisionId?: number
): Promise<{ ok: boolean; message?: string; errors?: string[]; data: any }> {
  const localApi = await getLocalApi();
  const divId = divisionId ?? getSelectedDivisionId();

  const url = apiConfig.accommodation_room_save
    .replace('{divisionId}', String(divId));

  const resp = await localApi.call(url, 'PUT', JSON.stringify(payload));
  
  if (!resp) {
    return { ok: false, message: 'No response from server', errors: ['No response from server'], data: { message: 'No response from server' } };
  }
  
  let rawText = '';
  try {
    rawText = await resp.text();
  } catch {
    rawText = '';
  }
  
  let data: any = null;
  
  if (rawText) {
    try {
      data = JSON.parse(rawText);
    } catch {
      data = { message: rawText };
    }
  }

  const errors = ApiErrors.extractAllErrors(data, resp, "Failed to save accommodation room");
  const message = resp.ok
    ? (data?.message || "Accommodation room saved")
    : ApiErrors.formatErrors(errors);
  
  return { ok: !!resp?.ok, message, errors: resp.ok ? undefined : errors, data };
}
